import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// routes
import Router from 'routes';
// theme
import ThemeProvider from 'theme';
//styles
import './index.css';
// components
import { StyledChart } from 'components/chart';
// context
import { AppDataProvider } from "./context/AppDataProvider";
import { AppDataContext } from "./context/Context";
//
import 'i18';
import AlertWrapper from './components/alert';
import {
    initializeKeycloakSession,
    isKeycloakEnabled
} from './auth/keycloak';


export default function App() {
    let [val, setVal] = useState(true);

    globalThis.forceUpdate = () => {
        setVal(!val);
    };

    useEffect(() => {
        if (!isKeycloakEnabled()) {
            return;
        }

        initializeKeycloakSession().then((authenticated) => {
            if (authenticated) {
                setVal((prev) => !prev);
            }
        });
    }, []);


    return (
        <HelmetProvider>
            <BrowserRouter>
                <ThemeProvider>
                    <StyledChart />
                    <AppDataProvider>
                        <AppDataContext.Consumer>
                            {value => <Router context={value}/>}
                        </AppDataContext.Consumer>
                        <AlertWrapper />
                    </AppDataProvider>
                </ThemeProvider>
            </BrowserRouter>
        </HelmetProvider>
    );
}
